import { render } from "./privacy-policy.html?vue&type=template&id=32d233a3&ts=true"
import script from "./privacy-policy.ts?vue&type=script&lang=ts"
export * from "./privacy-policy.ts?vue&type=script&lang=ts"

import "./privacy-policy.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__